export default {
  namespaced: true,

  state: () => ({
    detailData: {},
    isDetailData: false,
    verifyData: [],
    householdData: [],
    householdQueryData: {},
  }),

  mutations: {
    getDetailData(state, data) {
      console.log(data);
      state.detailData = data;
    },
    changeIsDetailData(state, data){
      console.log('vuex:', state, data)
      state.isDetailData = data
    },
    getVerifyData(state, data) {
      console.log(data);
      state.verifyData = data;
    },
    getHouseholdData(state, data) {
      state.householdData = data;
    },
    getHouseholdQueryData(state, data) {
      state.householdQueryData = data;
    },
    // clearDetailData(state, path) {
    //   state.detailData = [];
    // },
  },

  actions: {
    // getDetailData({ commit, state }, message) {
    //   state.cancelTokens.forEach((token) => {
    //     if (token.source.cancel) {
    //       token.source.cancel(message);
    //     }
    //   });
    //   commit('clearCancelToken');
    // },
  },

  getters: {
    getDetailData(state) {
      return state.detailData;
    },
    getVerifyData(state) {
      return state.verifyData;
    },
    getHouseholdData(state) {
      return state.householdData;
    },
  },
};
